import { ValidatorMessage } from '@web-for-marketing/react-ui';
import { mediaUrlPrefixToken, resolveImagePath } from './gallery';

export function replaceWithEditorSafeImageUrls(content: string, mediaUrlPrefix: string): string {
    return replaceStringInImageSource(content, mediaUrlPrefixToken, mediaUrlPrefix);
}

export function replaceWithDbSafeImageUrls(content: string, mediaUrlPrefix: string): string {
    return replaceStringInImageSource(content, mediaUrlPrefix, mediaUrlPrefixToken);
}

export function replaceStringInImageSource(content: string, lookupString: string, replacementString: string): string {
    const updatedContent = content;
    const replaceRegex = new RegExp(lookupString, 'gi');

    return updatedContent.replace(replaceRegex, replacementString);
}

export function wrapImageContentWithFigure(content: string): string {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    const images = doc.querySelectorAll('img');
    const imagesWithoutFigure = Array.from(images).filter((img) => !img.closest('figure'));

    function wrapElement(el: ParentNode, wrapper: HTMLElement): void {
        el.parentNode?.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    }

    imagesWithoutFigure.forEach((img) => {
        const classAttributeValue = img.getAttribute('class');
        const styleAttributeValue = img.getAttribute('style');

        img.removeAttribute('class');
        img.removeAttribute('style');

        const figure = document.createElement('figure');

        figure.setAttribute('class', `image ${classAttributeValue ? classAttributeValue : ''}`);
        styleAttributeValue && figure.setAttribute('style', styleAttributeValue);

        const wrappedWithAnchor = img.parentNode?.nodeName === 'A';
        const elementToWrap = wrappedWithAnchor ? img.parentNode : img;

        wrapElement(elementToWrap, figure);
    });

    const bodyTag = doc.childNodes[0].childNodes[1];

    return (bodyTag as HTMLElement).innerHTML;
}

export function removeImages(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const images = doc.querySelectorAll('img');

    images.forEach((img) => {
        let prevElement = img as HTMLElement;
        let currentElement = img.parentElement;

        while (currentElement?.parentElement != null && currentElement.childElementCount == 1) {
            prevElement = currentElement;
            currentElement = currentElement.parentElement;
        }

        currentElement?.removeChild(prevElement);
    });

    const strHtml = new XMLSerializer().serializeToString(doc);

    return strHtml;
}

export function updateImageSrc(html: string, urls: { [key: string]: string }, mediaUrlPrefix: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const images = doc.querySelectorAll('img');

    images.forEach((img) => {
        img.src = resolveImagePath(mediaUrlPrefix, urls[img.src]);
    });

    const strHtml = new XMLSerializer().serializeToString(doc);

    return strHtml;
}

export function validateImages(content: string): ValidatorMessage {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    const images = doc.querySelectorAll('img');

    const noAlt = Array.from(images).some((img) => !img.getAttribute('alt'));

    return noAlt ? 'All images must have an alt attribute' : null;
}

export function validateHeadersOrder(content: string, metadata: { headingLevel: number }): ValidatorMessage {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    let expectedLevel = metadata.headingLevel;
    const allHeaders = doc.querySelectorAll('h1, h2, h3, h4');

    if (allHeaders.length === 0) {
        return null;
    }

    for (const header of allHeaders) {
        const level = parseInt(header.tagName.substring(1));

        if (level < expectedLevel) {
            expectedLevel = level;
        }

        if (level > expectedLevel) {
            return 'All headers must have the right order: h1, h2, h3, h4. Heading levels should only increase by one.';
        }

        expectedLevel = level + 1;
    }

    return null;
}
